<template>
    <ul class="collapsible" id="group-summary-component">
        <li>
            <div class="collapsible-header">
                <div class="row w-100 mgb-0">
                    <div class="col s12 m3">
                        <i class="large material-icons past-icon lighten-2 align-middle">insert_chart</i>
                        <span class="align-middle">Past : </span>
                        <span class="align-middle"><b>{{ past }}</b></span>
                    </div>

                    <div class="col s12 m5">
                        <i class="large material-icons current-icon align-middle">insert_chart</i>
                        <span class="align-middle">Current : </span>
                        <span class="align-middle"><b>{{ current }}</b></span>
                        <span class="align-middle positive" v-if="improvement >= 0 && improvement !== null">
                            <i class="material-icons mr-0 align-middle">trending_up</i> {{ improvement }} %
                        </span>
                        <span class="align-middle negative" v-if="improvement < 0 && improvement !== null">
                            <i class="material-icons mr-0 align-middle">trending_down</i> {{ improvement }} %
                        </span>
                    </div>

                    <div class="col s12 m4">
                        <i class="large material-icons align-middle">recent_actors</i>
                        <span class="align-middle">Total O/S Issues : </span>
                        <span class="align-middle"><b>{{ totalOsIssues }}</b></span>
                    </div>
                </div>

            </div>

            <div class="collapsible-body">
                <div v-show="group !== null">
                    <!-- Past vs Current scores -->
                    <h5>Past vs Current scores</h5>
                    <hr>
                    <div class="row">
                        <div class="col s12">
                          <div class="card light-blue lighten-4">
                                <div class="card-content">
                                    <span class="card-title">Metadata</span>

                                    <p class="card-meta">
                                        <b>Past:</b> previous month of total stress scores of members (<b>{{ past_total }}</b>) / total member submitted (<b>{{ past_count }}</b>) = <b>{{ past }} %</b>
                                    </p>
                                    <div v-if="past_unsubmit_count > 0"  class="card-meta card-box deep-orange lighten-3">
                                        <i class="material-icons align-middle">info_outline</i>
                                        <span class="align-middle">{{ past_unsubmit_count }} members yet to submit.</span>
                                    </div>
                                    <div v-else class="card-meta card-box green lighten-3">
                                        <i class="material-icons align-middle">check_circle</i>
                                        <span class="align-middle">All member is submitted.</span>
                                    </div>

                                    <p class="mt-1 card-meta">
                                        <b>Current:</b> total stress scores of members (<b>{{ current_total }}</b>) / total member submitted (<b>{{ current_count }}</b>) = <b>{{ current }} %</b>
                                    </p>
                                    <div v-if="current_unsubmit_count > 0" class="card-meta card-box deep-orange lighten-3">
                                        <i class="material-icons align-middle">info_outline</i>
                                        <span class="align-middle">{{ current_unsubmit_count }} members yet to submit.</span>
                                    </div>
                                    <div v-else class="card-meta card-box green lighten-3">
                                        <i class="material-icons align-middle">check_circle</i>
                                        <span class="align-middle">All member is submitted.</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12 m7 l6 centered-grid">
                            <canvas id="groupScoreChart" v-show="current !== null && past !== null"></canvas>
                            <div id="chartjs-tooltip"></div>
                        </div>
                    </div>

                    <!-- Outstanding Issues List -->
                    <h5>Outstanding Issues List</h5>
                    <hr>
                    <div class="row">
                        <div class="col s12">
                            <table class="striped" ref="outstanding_issue_table" id="outstanding_issue_table">
                                <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Category</th>
                                    <th>Action</th>
                                </tr>
                                </thead>

                                <tbody>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div v-show="group === null" class="row">
                    <div class="col s12">
                        <div class="card-panel cyan lighten-4">
                            <i class="material-icons align-middle">info_outline</i>
                            <span class="align-middle">Select a group first</span>
                        </div>
                    </div>
                </div>

            </div>
        </li>
    </ul>
</template>

<script>
  export default {
    name: 'GroupSummaryComponent',
    props: {
      group: {
        type: Object,
        default: null
      },
      urlPdf: String,
      urlOutstandingIssueByUserGroup: String,
    },
    data () {
      return {
        current: null,
        current_total: 0,
        current_count: 0,
        current_unsubmit_count: 0,
        past: null,
        past_total: 0,
        past_count: 0,
        past_unsubmit_count: 0,
        totalOsIssues: null,

        loadedChart: null,

        issueTableLoaded: false,
        issueTable: null,
      }
    },
    computed: {
      improvement () {
        return this.current && this.past ? parseFloat((-(this.current - this.past) / this.past * 100).toFixed(2)) : null;
      }
    },
    watch: {
      group (item) {
        let current_scores = [];
        let previous_scores = [];
        this.current_unsubmit_count = 0;
        this.past_unsubmit_count = 0;
        this.totalOsIssues = 0;

        item.members.forEach(data => {
          if (data.current_month_score[0]) {
            current_scores.push(data.current_month_score[0].full_score)
          } else {
            this.current_unsubmit_count++;
          }

          if (data.last_month_score[0]) {
            previous_scores.push(data.last_month_score[0].full_score)
          } else {
            this.past_unsubmit_count++;
          }

          if (data.ongoing_issue_groups) {
            this.totalOsIssues += data.ongoing_issue_groups.length // array count
          }
        });

        if (current_scores.length > 0) {
          this.current_total = current_scores.reduce((sum, x) => sum + x);
          this.current_count = current_scores.length;
          this.current = parseFloat((this.current_total / this.current_count).toFixed(2));
        } else {
          this.current_total = 0;
          this.current_count = 0;
          this.current = 0;
        }

        if (previous_scores.length > 0) {
          this.past_total = previous_scores.reduce((sum, x) => sum + x);
          this.past_count = previous_scores.length;
          this.past = parseFloat((this.past_total / this.past_count).toFixed(2));
        } else {
          this.past_total = 0;
          this.past_count = 0;
          this.past = 0;
        }

        this.initChart()
        this.initOSIssueTable()
      }
    },
    mounted () {
      $('#group-summary-component').collapsible();
    },
    methods: {
      initChart() {
        var ctx = document.getElementById("groupScoreChart");
        ctx.height = 240;

        if (this.loadedChart) {
          this.loadedChart.destroy();
        }

        this.loadedChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Past', 'Current'],
            datasets: [{
              label: 'Stress Scores',
              data: [this.past, this.current],
              backgroundColor: [
                '#ff8a65',
                '#aed581',
              ]
            }]
          },
          options: {
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 30,
                bottom: 30
              }
            },
            responsive: true,
            legend: {
              position: 'bottom',
              labels: {
                boxWidth: 10,
                fontSize: 11,
                padding: 5
              }
            },
            scales: {
              xAxes: [{
                stacked: true, // this should be set to make the bars stacked
                ticks: {
                  fontSize: 10,
                  lineHeight: 1,
                  maxRotation: 0, // angle in degrees
                }
              }],
              yAxes: [{
                stacked: true, // this also..
                ticks: {
                  max: 100
                }
              }]
            },
          }
        });

        $('#groupScoreChart').css({'display': 'unset'});
      },

      initOSIssueTable () {
        if (this.issueTable) {
          this.issueTable.destroy()
        }

        let _urlPdf = this.urlPdf;
        this.issueTable = $('body').find('#outstanding_issue_table').DataTable({
          processing: true,
          serverSide: true,
          ajax: {
            method: 'GET',
            url: this.urlOutstandingIssueByUserGroup,
            data: {
              group_id: this.group.id
            }
          },
          columns: [
            {data: 'name', name: 'name'},
            {data: 'issue_category.title', name: 'issue_category.title'},
            {
              data: 'id', render: function (data, type, row) {
                return '<a href="' + _urlPdf + '/' + data + '" style="margin-right: 10px" target="_blank"><i class="material-icons">file_download</i></a>';
              }
            }
          ]
        });

      }
    }
  }
</script>

<style lang="scss" scoped>
    #group-summary-component {
        .collapsible-header {
            padding: 0.5rem;

            i {
                margin-right: 0.5rem;

                &.current-icon {
                    color: #aed581;
                }

                &.past-icon {
                    color: #ff8a65;
                }
            }

            .positive {
                color: #4267b2;
            }
            .negative {
                color: #e84949;
            }
        }

        table#outstanding_issue_table {
            width: 100% !important;
        }

        .card {
            .card-content {
                .card-title {
                    font-size: 1.2rem;
                    color: #252525;
                    font-weight: bold;
                }

                .card-meta {
                    color: #252525;
                    font-size: 1rem;
                }

                .card-box {
                    display: inline-block;
                    padding: 0.25rem 1.5rem;
                    border-radius: 0.5rem;
                    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/GroupSummaryComponent.vue